<ng-container *ngIf="getEnvName() as env">
  <div
    matTooltip="Won't show up in prod, just for internal use"
    class="environment-switcher w-full h-full rounded-lg flex flex-col items-center justify-center font-bold text-black opacity-50"
    [class.bg-red-500]="env === 'Prod'"
    [class.opacity-25]="env !== 'Prod'"
  >
    <div>Using {{ env }}</div>
  </div>
</ng-container>
